PJQ.collections.erpAdmin = PJQ.collections.erpAdmin  ?? {};
PJQ.models.erpAdmin = PJQ.models.erpAdmin  ?? {};
PJQ.views.erpAdmin = PJQ.views.erpAdmin  ?? {};
PJQ.constants.erpAdmin = PJQ.constants.erpAdmin ?? {};

PJQ.modules.erpAdmin = {
    routes: [
        {
            route: "erpadmin",
            name: 'erpadmin',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin"
                });
            }
        },
        {
            route: "erpadmin/project",
            name: 'erpadmin-project',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'project'
                    }
                });
            }
        },
        {
            route: "erpadmin/costcode",
            name: 'erpadmin-costcode',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'costcode'
                    }
                });
            }
        },
        {
            route: "erpadmin/subjob",
            name: 'erpadmin-subjob',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'subjob'
                    }
                });
            }
        },
        {
            route: "erpadmin/cont_comp",
            name: 'erpadmin-company',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'cont_comp'
                    }
                });
            }
        },
        {
            route: "erpadmin/budget",
            name: 'erpadmin-budget',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'budget'
                    }
                });
            }
        },
        {
            route: "erpadmin/commitment",
            name: 'erpadmin-commitment',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'commitment'
                    }
                });
            }
        },
        {
            route: "erpadmin/cco",
            name: 'erpadmin-cco',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'cco'
                    }
                });
            }
        },
        {
            route: "erpadmin/ap_inv",
            name: 'erpadmin-payableinvoices',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'ap_inv'
                    }
                });
            }
        },
        {
            route: "erpadmin/ar_inv",
            name: 'erpadmin-receivableinvoices',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'ar_inv'
                    }
                });
            }
        },
        {
            route: "erpadmin/contract",
            name: 'erpadmin-contract',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'contract'
                    }
                });
            }
        },
        {
            route: "erpadmin/pcco",
            name: 'erpadmin-pcco',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'pcco'
                    }
                });
            }
        },
        {
            route: "erpadmin/d_cost",
            name: 'erpadmin-directcosts',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'd_cost'
                    }
                });
            }
        },
    ]
};

PJQ.app.addRoutes(PJQ.modules.erpAdmin.routes);
